import primeCatalog from './prime';
import checkoutCatalog from './checkout';
import ancillariesCatalog from './ancillaries';
import additionalProductsCatalog from './additional_products';
import dynpackCatalog from './dynpack';
import flightsCatalog from './flights';
import mytripsCatalog from './mytrips';
import nagsCatalog from './nags';
import checkinCatalog from './checkin';
import attractCatalog from './attract';

// Merge all the business catalogs
export default new Set([
    ...primeCatalog,
    ...checkoutCatalog,
    ...ancillariesCatalog,
    ...additionalProductsCatalog,
    ...nagsCatalog,
    ...dynpackCatalog,
    ...flightsCatalog,
    ...mytripsCatalog,
    ...checkinCatalog,
    ...attractCatalog,
]);
